import {ChangeDetectorRef, Component, Inject, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataBrokerService} from '../../../../core/services/data-broker/data-broker.service';
import {PerformerModel, UpdatePerformer} from '../../../../core/models/performer.model';
import {SnackbarComponent} from '../../../components/snackbar/snackbar.component';
import {Provider, ProviderUpdatedResponse} from '../../../../core/models/provider.model';
import {ProviderService} from '../../../../core/services/provider/provider.service';
import {Router} from '@angular/router';
import {DateUtility} from '../../../../core/utils/date-utility';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {PrProfileComponent} from './pr-profile/pr-profile.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BreadcrumbService} from '../../../../core/services/breadcrumb/breadcrumb.service';
import {Observable} from 'rxjs';
import config from '../../../../../config';

interface DialogData {
  mode: string;
  active: any;
  organizationId: string;
  provider: PerformerModel;
  isAdminList: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-pr-onboard-dialog',
  templateUrl: './pr-onboard-dialog.component.html',
  styleUrls: ['./pr-onboard-dialog.component.scss'],
})
export class PrOnboardDialogComponent implements OnInit {
  public labels: {[key: string]: string};
  public isLoaded = false;
  public selectedTab: string;
  public navTitles: any[] = [];

  public accountInfoLabel: string;
  public provider: UpdatePerformer;

  @ViewChild('providerProfile', {static: false}) private profileTab: PrProfileComponent;

  private snackBarConf: MatSnackBarConfig = {
    duration: 0,
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  constructor(
    public dialogRef: MatDialogRef<PrOnboardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private providerService: ProviderService,
    private router: Router,
    private dateUtility: DateUtility,
    private snackBar: MatSnackBar,
    private dataBrokerService: DataBrokerService,
    private breadcrumb: BreadcrumbService,
    private cd: ChangeDetectorRef
  ) {
    const languageUpdate$ = this.dataBrokerService.subscribe('language-update');

    this.updateLanguage();
    languageUpdate$.pipe(untilDestroyed(this)).subscribe(this.updateLanguage.bind(this));
  }

  ngOnInit() {
    this.getNavTitle();
    if (this.data.mode === 'edit') {
      let getProvider$: Observable<Provider>;
      if (this.data && this.data.isAdminList) {
        if (this.data && this.data.provider && this.data.provider.performerId) {
          getProvider$ = this.data.provider
            ? this.providerService.getProviderById(this.data.provider.performerId)
            : this.providerService.getSelectedProvider();
        } else {
          this.provider = new UpdatePerformer();
          this.provider.id = this.data.provider.id;
          this.provider.links = this.data.provider.links;
          this.provider.updateProfileInfo.firstName = this.data.provider.firstName;
          this.provider.updateProfileInfo.lastName = this.data.provider.lastName;
          this.provider.updateAccountInfo.emailAddress = this.data.provider.email;
          this.provider.updateAccountInfo.phoneNumber = this.data.provider.phoneNumber;
          this.provider.updateAccountInfo.workNumber = this.data.provider.workNumber;
          this.provider.updateAccountInfo.workNumberExt = this.data.provider.workNumberExtension;
          this.provider.updateAccountInfo.userName = this.data.provider.userName;
          this.provider.updateAccountInfo.privilege = this.data.provider.privilege;
          this.isLoaded = true;
        }
      } else {
        getProvider$ = this.data.provider
          ? this.providerService.getProviderById(this.data.provider.performerId)
          : this.providerService.getSelectedProvider();
      }
      this.getProvider(getProvider$);
    } else {
      this.provider = new UpdatePerformer();
      this.isLoaded = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['active']) {
      if (this.data.active && this.profileTab) {
        this.profileTab.setupForm();
      }
    }
  }

  getProvider(getProvider$: Observable<Provider>) {
    if (getProvider$) {
      getProvider$.pipe(untilDestroyed(this)).subscribe((provider) => {
        this.provider = new UpdatePerformer();
        this.provider.id = provider.id;
        this.provider.links = provider.links;
        this.provider.updateProfileInfo.firstName = provider.firstName;
        this.provider.updateProfileInfo.lastName = provider.lastName;
        this.provider.updateProfileInfo.medicalLicenseId = provider.medicalLicense;
        this.provider.updateProfileInfo.pharmacistNPI = provider.pharmacistNPI;
        // this.provider.updateProfileInfo.deaNumber = provider.deaNumber;
        this.provider.updateAccountInfo.employeeId = provider.employeeId;
        this.provider.updateProfileInfo.organizationName = provider.organization;
        if (provider.department) {
          this.provider.updateProfileInfo.organizationId = provider.department.organizationId;
          this.provider.updateProfileInfo.departmentObj = provider.department;
          this.provider.updateProfileInfo.departmentId = provider['departmentId'];
        }
        this.provider.updateProfileInfo.specialtiesObj = provider.specialties;
        this.provider.updateProfileInfo.dateOfBirth = this.dateUtility.formatDateUTC(
          new Date(provider.dateOfBirth),
          'MM/DD/YYYY'
        );
        this.provider.updateProfileInfo.gender = provider.gender;
        this.provider.updateProfileInfo.nationality = provider.nationality;
        this.provider.updateProfileInfo.languages = provider.languages;
        this.provider.updateProfileInfo.profileImage = provider['profileImage'];

        this.provider.updateAccountInfo.emailAddress = provider.email;
        this.provider.updateAccountInfo.phoneNumber = provider.phoneNumber;
        this.provider.updateAccountInfo.workNumber = provider.workNumber;
        this.provider.updateAccountInfo.workNumberExt = provider.workNumberExtension;
        this.provider.updateAccountInfo.userName = provider.userName;
        this.provider.updateAccountInfo.privilege = this.data.provider.privilege;
        this.provider.updateLocations.locations = provider.locations ? provider.locations : [];
        this.isLoaded = true;
      });
    }
  }

  public getNavTitle() {
    this.navTitles = [this.labels.accountInfo, this.labels.profile, this.labels.locations];
    this.selectedTab = this.navTitles[0];
  }

  // public selectNavTab(tab: string, isTab: boolean): void {
  //   if (this.navTitles.includes(tab) && this.selectedTab !== tab) {
  //     // if edit + from tab OR from navigation button
  //     if ((this.data.mode === 'edit' && isTab) || !isTab) {
  //       this.selectedTab = tab;
  //     }
  //   }
  // }

  providerProfileNext(provider: UpdatePerformer) {
    if ([config.PRIVILEGEID.USER, config.PRIVILEGEID.COORDINATOR, config.PRIVILEGEID.NON_IMMUNIZER].indexOf(+provider.updateAccountInfo.privilege.id) != -1) {
      this.finishEvent(provider);
    } else {
      this.nextTab(provider);
    }
  }

  public nextTab(provider: UpdatePerformer) {
    this.provider = provider;

    this.selectedTab = this.navTitles[this.navTitles.findIndex((nt) => nt === this.selectedTab) + 1];
  }

  public backTab(provider: UpdatePerformer) {
    this.provider = provider;
    this.selectedTab = this.navTitles[this.navTitles.findIndex((nt) => nt === this.selectedTab) - 1];
  }

  public hideTabs({isAdmin, privilegeId}: {isAdmin: boolean; privilegeId: number}) {
    if (isAdmin) {
      this.navTitles = [this.labels.accountInfo];
      this.selectedTab = this.navTitles[0];
    } else {
      this.navTitles = [this.labels.accountInfo, this.labels.profile];
      // if (privilegeId !== 4) this.navTitles.push(this.labels.locations);
      this.selectedTab = this.navTitles[0];
    }
    this.cd.detectChanges();
  }

  public finishEvent(provider) {
    const mode = provider && provider.id ? 'updateProvider' : 'createProvider';
    this.provider = provider;
    this.provider.updateProfileInfo.specialties = this.provider.updateProfileInfo.specialtiesObj?.map((s) => s.id);
    this.provider.updateProfileInfo.firstName = provider.updateAccountInfo.firstName;
    this.provider.updateProfileInfo.lastName = provider.updateAccountInfo.lastName;

    if (!this.provider.updateProfileInfo.profileImage && mode === 'updateProvider') {
      this.provider.updateProfileInfo.profileImage = 'empty';
    }
    if (
      mode === 'createProvider' &&
      this.provider.updateProfileInfo.departmentObj &&
      typeof this.provider.updateProfileInfo.departmentObj === 'object'
    ) {
      this.provider.updateProfileInfo.department = Number(this.provider.updateProfileInfo.departmentObj.id);
    }

    delete this.provider.updateProfileInfo.organizationName;
    delete this.provider.updateProfileInfo.departmentId;
    delete this.provider.updateProfileInfo.departmentObj;

    this.isLoaded = false;

    this[mode]();
  }

  public createProvider() {
    // because emp_id column is in account info, not profile info
    this.provider.updateAccountInfo.employeeId = this.provider.updateProfileInfo['employeeId'];
    this.provider.updateProfileInfo['employeeId'] = null;

    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.snackBarConf,
      data: 'Creating new provider',
    });
    this.providerService.createProvider(this.provider).subscribe(
      (provider: ProviderUpdatedResponse) => {
        this.dataBrokerService.publish<ProviderUpdatedResponse>(provider, 'provider');
        this.dataBrokerService.publish(provider, 'update-provider-list');

        this.snackBar.open('Created Successfully!', '', {...this.snackBarConf, duration: 2000});

        this.isLoaded = true;
        this.onClose(provider);
        this.selectedTab = this.navTitles[0];
      },
      () => {
        this.snackBar.open('Could not create new provider', '', {...this.snackBarConf, duration: 2000});
        this.isLoaded = true;
      }
    );
  }

  public updateProvider() {
    this.provider.updateAccountInfo.employeeId = this.provider.updateProfileInfo['employeeId'];
    this.provider.updateProfileInfo['employeeId'] = null;

    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.snackBarConf,
      data: 'Updating provider',
    });
    if (this.provider.updateProfileInfo.department) {
      this.provider.updateProfileInfo.department = this.provider.updateProfileInfo.department['id'];
    }
    this.providerService.updateProvider(this.provider).subscribe(
      (provider: ProviderUpdatedResponse) => {
        this.snackBar.open('Update Successfully!', '', {...this.snackBarConf, duration: 2000});

        if (this.router.url === '/curapatient/providers/provider') {
          this.dataBrokerService.publish<string>(provider.name, 'title');
        }
        this.dataBrokerService.publish(provider, 'update-provider-list');
        this.breadcrumb.updateBreadcrumbs([
          {label: 'Providers', url: '/curapatient/providers'},
          {
            label: this.provider.updateProfileInfo.firstName + ' ' + this.provider.updateProfileInfo.lastName,
            url: '/curapatient/providers/provider',
          },
        ]);
        this.onClose(provider);
      },
      () => {
        this.snackBar.open('Could not update provider', '', {...this.snackBarConf, duration: 2000});
        this.onClose();
      }
    );
  }

  public deleteProvider() {
    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.snackBarConf,
      data: 'Deleting provider',
    });

    this.providerService.deleteProvider(this.provider).subscribe(
      () => {
        this.snackBar.open('Deleted Successfully!', '', {...this.snackBarConf, duration: 3000});
        this.onClose({});
      },
      () => {
        this.snackBar.open('Deleting Failure!', '', {...this.snackBarConf, duration: 2000});
        this.onClose();
      }
    );
  }

  onClose(value = null): void {
    this.dialogRef.close(value);
  }

  private updateLanguage() {
    this.labels = {
      title: '',
      profile: 'Provider Info',
      accountInfo: 'Account Info',
      locations: 'Locations',
    };
  }
}
